import { useState, useEffect } from "react";
import { useAuth } from "../../context/auth-context";
import { DasboardContext } from "../../context/dashboard-context";
import { useContext } from "react";

import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";

import logo from "../../assets/images/logo.png";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash, FaExclamationCircle, FaSpinner } from "react-icons/fa";

const Login = () => {
  const { login, isAuthenticated, loading: authLoading } = useAuth();
  const { setUserInfo } = useContext(DasboardContext);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Eğer zaten giriş yapılmışsa homepage'e yönlendir
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/homepage", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Input validation
    if (!username.trim() || !password.trim()) {
      setError("Lütfen kullanıcı adı ve şifrenizi giriniz.");
      return;
    }

    setIsLoading(true);

    try {
      const result = await login(username, password, rememberMe);

      if (result.success) {
        // Dashboard context'e kullanıcı bilgilerini kaydet
        setUserInfo(result.user);
        // State güncellemesinin tamamlanması için kısa bir bekleme
        await new Promise(resolve => setTimeout(resolve, 100));
        // Başarılı giriş sonrası homepage'e yönlendir
        navigate("/homepage", { replace: true });
    } else {
        setError(result.error || "Giriş başarısız oldu. Lütfen tekrar deneyin.");
        setPassword(""); // Güvenlik için şifreyi temizle
      }
    } catch (err) {
      setError("Bir hata oluştu. Lütfen tekrar deneyin.");
      setPassword("");
    } finally {
      setIsLoading(false);
    }
  };

  // Auth yükleniyorsa loading göster
  if (authLoading) {
    return (
      <div className="login-wrapper">
        <div className="loading-container">
          <FaSpinner className="spinner" />
          <p>Yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="logo-section">
      <div className="logo">
            <img src={logo} alt="Viva Smart Care Logo" />
          </div>
          <h3>Viva Smart Care</h3>
          <p className="subtitle">Yönetim Paneli</p>
        </div>

        <Form className="form-wrapper" onSubmit={handleSubmit}>
          {error && (
            <div className="error-message" role="alert">
              <FaExclamationCircle className="error-icon" />
              <span>{error}</span>
              <button
                type="button"
                className="error-close"
                onClick={() => setError("")}
                aria-label="Hata mesajını kapat"
              >
                ×
              </button>
      </div>
          )}

          <Form.Group className="form-group">
            <label htmlFor="username">Kullanıcı Adı</label>
            <div className="input-wrapper">
          <Form.Control
                id="username"
            type="text"
                placeholder="Kullanıcı adınızı giriniz"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
                disabled={isLoading}
            required
                autoComplete="username"
                className={error && !username ? "error" : ""}
          />
            </div>
        </Form.Group>

          <Form.Group className="form-group">
            <label htmlFor="password">Şifre</label>
            <div className="input-wrapper password-wrapper">
            <Form.Control
                id="password"
              type={showPassword ? "text" : "password"}
                placeholder="Şifrenizi giriniz"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
              required
                autoComplete="current-password"
                className={error && !password ? "error" : ""}
            />
              <button
                type="button"
                className="password-toggle"
              onClick={togglePasswordVisibility}
                disabled={isLoading}
                aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
          </div>
        </Form.Group>

        <Form.Group className="remember-forget">
            <Form.Check
              type="switch"
              id="remember-me"
              label="Beni Hatırla"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              disabled={isLoading}
            />
            <Link to={"/forget-password"} className="forgot-link">
              Şifremi Unuttum
            </Link>
        </Form.Group>

          <Button
            variant="primary"
            type="submit"
            disabled={isLoading}
            className="login-button"
          >
            {isLoading ? (
              <>
                <FaSpinner className="button-spinner" />
                Giriş yapılıyor...
              </>
            ) : (
              "Giriş Yap"
            )}
          </Button>

          <div className="signup-link">
            <span>Hesabınız yok mu?</span>
          <Link to={"/sign-in"}>Üye Ol</Link>
          </div>
      </Form>
      </div>
    </div>
  );
};

export default Login;
